module.exports = __webpack_public_path__ + "static/media/onder_een_mandarijn_boom.4863109e.jpg";